import { produce } from "immer";
import {
  FETCH_CARE_PLAN_EQUIPMENT,
  FETCH_CARE_PLAN_EQUIPMENT_SUCCESS,
  FETCH_CARE_PLAN_EQUIPMENT_FAILURE,
  FETCH_ACTIVE_EQUIPMENT_REGISTER,
  FETCH_ACTIVE_EQUIPMENT_REGISTER_SUCCESS,
  FETCH_ACTIVE_EQUIPMENT_REGISTER_FAILURE,
  FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE,
  FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_SUCCESS,
  FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_FAILURE,
  ADD_CARE_PLAN_EQUIPMENT,
  ADD_CARE_PLAN_EQUIPMENT_SUCCESS,
  ADD_CARE_PLAN_EQUIPMENT_FAILURE,
  EDIT_CARE_PLAN_EQUIPMENT,
  EDIT_CARE_PLAN_EQUIPMENT_SUCCESS,
  EDIT_CARE_PLAN_EQUIPMENT_FAILURE,
  DELETE_CARE_PLAN_EQUIPMENT,
  DELETE_CARE_PLAN_EQUIPMENT_SUCCESS,
  DELETE_CARE_PLAN_EQUIPMENT_FAILURE,
  MARK_PROVIDED_CARE_PLAN_EQUIPMENT,
  MARK_PROVIDED_CARE_PLAN_EQUIPMENT_SUCCESS,
  MARK_PROVIDED_CARE_PLAN_EQUIPMENT_FAILURE,
  MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT,
  MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_SUCCESS,
  MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_FAILURE,
  MARK_REPLACED_CARE_PLAN_EQUIPMENT,
  MARK_REPLACED_CARE_PLAN_EQUIPMENT_SUCCESS,
  MARK_REPLACED_CARE_PLAN_EQUIPMENT_FAILURE,
} from "./constants";

export const initialState = {
  equipment: {},
  // Resident-wide ACTIVE register snapshot (dedup hints) — parallel to the
  // paginated `equipment` page above, never mixed with it.
  activeRegister: [],
  catalogue: [],
  isFetchingEquipment: false,
  isFetchingActiveRegister: false,
  isFetchingCatalogue: false,
  isSubmitting: false,
  isDeleting: false,
  isTransitioning: false,
};

const CarePlanEquipmentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CARE_PLAN_EQUIPMENT:
        draft.isFetchingEquipment = true;
        break;
      case FETCH_CARE_PLAN_EQUIPMENT_SUCCESS:
        draft.isFetchingEquipment = false;
        draft.equipment = action.payload;
        break;
      case FETCH_CARE_PLAN_EQUIPMENT_FAILURE:
        draft.isFetchingEquipment = false;
        break;

      case FETCH_ACTIVE_EQUIPMENT_REGISTER:
        draft.isFetchingActiveRegister = true;
        break;
      case FETCH_ACTIVE_EQUIPMENT_REGISTER_SUCCESS:
        draft.isFetchingActiveRegister = false;
        draft.activeRegister = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];
        break;
      case FETCH_ACTIVE_EQUIPMENT_REGISTER_FAILURE:
        draft.isFetchingActiveRegister = false;
        break;

      case FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE:
        draft.isFetchingCatalogue = true;
        break;
      case FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_SUCCESS:
        draft.isFetchingCatalogue = false;
        draft.catalogue = action.payload?.data ?? action.payload ?? [];
        break;
      case FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_FAILURE:
        draft.isFetchingCatalogue = false;
        break;

      case ADD_CARE_PLAN_EQUIPMENT:
      case EDIT_CARE_PLAN_EQUIPMENT:
        draft.isSubmitting = true;
        break;
      case ADD_CARE_PLAN_EQUIPMENT_SUCCESS:
      case EDIT_CARE_PLAN_EQUIPMENT_SUCCESS:
      case ADD_CARE_PLAN_EQUIPMENT_FAILURE:
      case EDIT_CARE_PLAN_EQUIPMENT_FAILURE:
        draft.isSubmitting = false;
        break;

      case DELETE_CARE_PLAN_EQUIPMENT:
        draft.isDeleting = true;
        break;
      case DELETE_CARE_PLAN_EQUIPMENT_SUCCESS:
      case DELETE_CARE_PLAN_EQUIPMENT_FAILURE:
        draft.isDeleting = false;
        break;

      case MARK_PROVIDED_CARE_PLAN_EQUIPMENT:
      case MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT:
      case MARK_REPLACED_CARE_PLAN_EQUIPMENT:
        draft.isTransitioning = true;
        break;
      case MARK_PROVIDED_CARE_PLAN_EQUIPMENT_SUCCESS:
      case MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_SUCCESS:
      case MARK_REPLACED_CARE_PLAN_EQUIPMENT_SUCCESS:
      case MARK_PROVIDED_CARE_PLAN_EQUIPMENT_FAILURE:
      case MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_FAILURE:
      case MARK_REPLACED_CARE_PLAN_EQUIPMENT_FAILURE:
        draft.isTransitioning = false;
        break;

      default:
        return state;
    }
  });

export default CarePlanEquipmentReducer;
